import { Component, Input } from '@angular/core';
import { TextDocument } from '../../dataService';

@Component({
  selector: 'app-document-text',
  templateUrl: './document-text.component.html',
  styleUrls: ['./document-text.component.scss']
})
export class DocumentTextComponent {
  @Input() document: TextDocument | null = null;
  @Input() isLoading = false;
  @Input() isError = false;

  get documentHtml(): string {
    if (!this.document || !this.document.versions || !this.document.versions[0]) {
      return '';
    }
    return this.document.versions[0].text || '';
  }
}